import axiosInstance from '../utils/axios';

export interface User {
  id: number;
  username: string;
  email: string;
  name: string;
  phone?: string;
  role: string;
  status: string;
  lastLoginTime: string;
}

export interface LoginData {
  username: string;
  password: string;
}

export interface RegisterData {
  username: string;
  password: string;
  name: string;
  email?: string;
  phone?: string;
}

export const userService = {
  // 获取所有用户
  getAllUsers: async () => {
    const response = await axiosInstance.get('/users');
    // 后端返回格式: { success: true, data: users[], total: number, ... }
    // 需要提取 data 字段中的用户数组
    return response.data.data || [];
  },


  // 创建用户
  createUser: async (userData: RegisterData) => {
    const response = await axiosInstance.post('/users', userData);
    return response.data;
  },

  // 更新用户
  updateUser: async (id: number, userData: Partial<User>) => {
    const response = await axiosInstance.put(`/users/${id}`, userData);
    return response.data;
  },

  // 删除用户
  deleteUser: async (id: number) => {
    const response = await axiosInstance.delete(`/users/${id}`);
    return response.data;
  },

  // 修改密码
  changePassword: async (userID: number, oldPassword: string, newPassword: string) => {
    const response = await axiosInstance.post('/users/change-password', {
      userID,
      oldPassword,
      newPassword,
    });
    return response.data;
  },
}; 